module.exports = __webpack_public_path__ + "img/logo_sunix.570b7822.png";